var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-box",style:(`background-color: ${_vm.backgroundColor};`)},[_c('icon',{staticClass:"icon-box__icon",attrs:{"name":_vm.name,"variant":_vm.variant}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }